import React from 'react';
import './Divider.css';

export interface DividerProps {
  /** Orientation of the divider */
  orientation?: 'horizontal' | 'vertical';
  /** Optional label text */
  label?: string;
  /** Additional CSS classes */
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  label,
  className = '',
}) => {
  const classNames = [
    'ui-divider',
    `ui-divider--${orientation}`,
    label && 'ui-divider--with-label',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (label && orientation === 'horizontal') {
    return (
      <div className={classNames} role="separator">
        <span className="ui-divider__label">{label}</span>
      </div>
    );
  }

  return <hr className={classNames} />;
};

Divider.displayName = 'Divider';
